module.exports = __webpack_public_path__ + "img/checks.554cb9a5.png";